import { z } from "zod";

import { LayoutAccessibility, LayoutRecord } from "./LayoutRecord";

export type CreateLayoutFormFields = Pick<
  LayoutRecord,
  "name" | "accessibility" | "tags" | "folder"
>;

export const createLayoutFormSchema = z.object({
  accessibility: z.enum(LayoutAccessibility, {
    error: "Layout owner is required",
  }),
  folder: z
    .string()
    .max(120, "Folder name cannot exceed 120 characters")
    .optional(),
  name: z
    .string()
    .min(1, "Layout name is required")
    .max(120, "Layout name cannot exceed 120 characters"),
  tags: z.array(z.string()).default([]),
}) satisfies z.ZodType<CreateLayoutFormFields>;

export type RenameLayoutFormFields = Pick<LayoutRecord, "name">;

export const renameLayoutFormSchema = createLayoutFormSchema.pick({
  name: true,
}) satisfies z.ZodType<RenameLayoutFormFields>;
